const getDefaultState = () => {
  return {
    all: [],
    loading: false,
  }
}

export const api = {
  getFeedbackRequests: opportunity => {
    return Vue.$http.get(`admin/opportunities/${opportunity.id}/feedback_requests`)
  },
}

const state = getDefaultState()

const getters = {
  find: state => id => state.all.find(fr => fr.id === id),
  forApplication: state => id => state.all.filter(fr => fr.opportunityApplication.id === id),
}

const mutations = {
  setAll(state, feedbackRequests) {
    state.all = JSON.parse(JSON.stringify(feedbackRequests))
  },

  resetState(state) {
    Object.assign(state, getDefaultState())
  },

  setLoading(state, loading) {
    state.loading = !!loading
  },
}

const actions = {
  fetchAll({ commit }, opportunity) {
    this.$authorize('read', 'OpportunityApplication')

    commit('setLoading', true)
    return api.getFeedbackRequests(opportunity).then(
      ({ data }) => {
        commit('setLoading', false)
        commit('setAll', data)
        return data
      },
      errors => {
        commit('setLoading', false)
        throw errors
      }
    )
  },

  resetState({ commit }) {
    commit('resetState')
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
